import React from "react";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";

const Info = () => {
  return (
    <div className="wrap main_wrap">
      <Header />
      <div className="commu_wrap">
        <div className="commu_banner_box">
          <div
            className="commu_banner animate__animated animate__fadeIn"
            style={{ animationDuration: "2s" }}
          ></div>
          <div className="banner_text_box">
            <div className="banner_title">커뮤니티</div>
            <div className="banner_text">중요 성장 정보</div>
          </div>
        </div>
        <div className="info_box">
          <div className="info_back">
            <div className="info_container left">
              <div className="info_row left">
                <div className="info_contents_box">
                  <div className="info_title">
                    성장발달 심층상담 교육강의를 진행하였습니다.
                  </div>
                  <div className="info_text">
                    이번에 소아청소년과 의사회에서 전문의선생님들을 대상으로
                    심층 상담교육을 지속적으로 진행하고 있습니다. 저도
                    교육강사로 '성장'관련 강의를 진행하였습니다. 36개월 이전의
                    아가들의 성장 발달검사를 전국 소아청소년과에서 심층 상담
                    신청하시고 상담 받으실 수있습니다. 감기 진료와 성장상담을
                    함께 하기는 어렵기 때문에 따로 신청을 하고 진행하신다면
                    선생님들께서 좀더 세심히 상담해주실것입니다. 물론, 소정의
                    상담 비용이 부과가 됩니다.^^;;
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2023.04.11</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/223071307009"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              <div className="info_row middle_left">
                <div className="info_contents_box">
                  <div className="info_title">
                    성조숙증 주의사항! 의학채널'비온뒤'강의
                  </div>
                  <div className="info_text">
                    의학채널 '비온뒤' 강의 요청으로 '성조숙증'관련 강의를
                    진행하였습니다. 진료실에서 못다한 내용들 모두 담았습니다.
                    주사 치료 외 어떤 것을 주의해야할까요?
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.07.27</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222831062613"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              <div className="info_row left">
                <div className="info_contents_box">
                  <div className="info_title">
                    키움성장클리닉, 카카오채널 친구하세요. '키움성장'
                  </div>
                  <div className="info_text">
                    본 병원 진료중인 경우 간단 상담 / 예약 문의주시면됩니다.
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.04.28</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222714157318"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              <div className="info_row middle_left">
                <div className="info_contents_box">
                  <div className="info_title">
                    만12세 이상 비만치료제 삭센다 주사
                  </div>
                  <div className="info_text">
                    코로나로 비만 아동이 폭증하고 있습니다. 한국 미국에서
                    FDA식약처에서 청소년 비만약으로 유일하게 승인된 비만치료제
                    삭센다 주사가 출시되었습니다.! 현재 성인에서도 안전하게
                    쓰이고있습니다. 인슐린 주사 바늘처럼 아주 작고 통증이 작은
                    특수 바늘로 복부에 주사 하게됩니다. 만12세부터 시작할 수
                    있습니다. 안전하며 장기 사용이 가능한 약제로 오심
                    소화불량등의 부작용이 간혹 있을 수 있습니다. 내분비 세부전문
                    청소년전문 의사의 진료와 상담 후 시작하세요.
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.03.31</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222687834274"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="info_container right">
              <div className="info_row right">
                <div className="info_contents_box">
                  <div className="info_title">
                    반드시알아야할 키성장 핵심중 핵심! 강의
                  </div>
                  <div className="info_text">
                    키성장을 위해 어떤 요소가 가장 중요한 핵심 포인트일까요?
                    의학채널 '비온뒤'에서 이에 대한 강의를 진행했습니다.
                    도움되시길 바래요~
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.10.13</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222899064400"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              <div className="info_row right">
                <div className="info_contents_box">
                  <div className="info_title">
                    {"<"}강연{">"}키크는 음식 -의학채널 '비온뒤'
                  </div>
                  <div className="info_text">
                    의학채널 비온뒤에서 강의 요청을 받았습니다. 키성장에 중요한
                    음식들 정리해서 이야기 나눠보았습니다. 키크는 음식
                    따로있습니다.! 한번 쯤 시청해주세요~~~^^
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.07.14</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222811273960"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              <div className="info_row middle_right">
                <div className="info_contents_box">
                  <div className="info_title">
                    원장님 논문 유명학회지에 등재되었습니다.!!! 성조숙증 유병률,
                    성조숙에 대한 연구
                  </div>
                  <div className="info_text">
                    성조숙증이 최근 수년간 급격히 증가하고 있습니다.
                    대학병원에서 부터 연구해 왔던 성조숙증의 유병률에 대한
                    결과가 드디어 '해외 유명 저널'에 publish 되었습니다. 너무
                    기쁜 나머지 제 이름 KYOUNG HUH아래 빨간줄 쳐놨습니다. 그동안
                    수많은 성조숙증 친구들 설문하고 혈액검사하고, 통계 작업
                    돌리고 했던 과정들이 드디어 빛을 보았군요. PLOS one이란
                    저널은 특히나 공신력있으며 impact facfor가 높은 연구로서
                    까다로운 심사를 통해 정확하고 신뢰높은 연구만 선정하는
                    저널입니다. 보통 의사로서 PLOS one에 연구논문이 실리게 되면
                    '노벨상'받은것 처럼 영광스럽게 여긴답니다. 혼자 조용히
                    영광의 V를 날려봅.......
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2022.04.08</div>
                    <div
                      className="info_btn"
                      onClick={() =>
                        window.open(
                          "https://blog.naver.com/h_kyoung/222695097219"
                        )
                      }
                    >
                      자세히보기
                    </div>
                  </div>
                </div>
              </div>
              {/*<div className="info_row right">
                <div className="info_contents_box">
                  <div className="info_title">
                    성장발달 심층상담 교육강의를 진행하였습니다.
                  </div>
                  <div className="info_text">
                    이번에 소아청소년과 의사회에서 전문의선생님들을 대상으로
                    심층 상담교육을 지속적으로 진행하고 있습니다. 저도
                    교육강사로 ‘성장’관련 강의를 진행하였습니다. 36개월 이전의
                    아가들의 성장 발달검사를 전국 소아청소년과에서 심층 상담
                    신청하시고 상담 받으실 수있습니다. 감기 진료와 성장상담을
                    함께 하기는 어렵기 때문에 따로 신청을 하고 진행하신다면
                    선생..
                  </div>
                  <div className="info_bottom_box">
                    <div className="info_date">2023.12.04</div>
                    <div className="info_btn">자세히보기</div>
                  </div>
                </div>
                </div> */}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Info;
